/* @flow */
// typecheck: ignore file
import React from 'react';
import EmailMergeConfirmDialog from 'user/components/EmailMergeConfirmDialog.jsx';
import EmailMergeConfirmationCode from 'user/components/EmailMergeConfirmationCode.jsx';
import AlertDialog from 'components/AlertDialog.jsx';
import EventTracking from 'lib/EventTracking';

type Page =
  'exists' |
  'confirmation_code' |
  'success';

type State = {
  page: Page,
};

type Props = {
  oldUserEmail: string,
  errorMessage: string,
  eventScreenName: string,
  onDone: Function,
  onRequestHide?: Function,
};

class EmailMergeConfirmation extends React.Component {
  props: Props;

  state: State = {
    page: 'exists',
  }

  renderEmailMergeConfirmDialog(onNext: Function) {
    return (
      <EmailMergeConfirmDialog
        message={this.props.errorMessage}
        oldUserEmail={this.props.oldUserEmail}
        onDone={onNext}
        onRequestHide={this.props.onRequestHide}
        eventScreenName={this.props.eventScreenName}
      />
    );
  }

  renderEmailMergeConfirmationCode(onNext: Function) {
    return (
      <EmailMergeConfirmationCode
        onDone={onNext}
        eventScreenName={this.props.eventScreenName}
        oldUserEmail={this.props.oldUserEmail}
        onRequestHide={this.props.onRequestHide}
      />
    );
  }

  renderSuccessfulMergeConfirmation() {
    return (
      <AlertDialog
        eventScreenName="EmailMergeConfirmation"
        title="Your accounts have been merged!"
        onRequestHide={this.props.onRequestHide}
        onOkay={this.props.onDone}
      />
    );
  }

  getPage() {
    switch (this.state.page) {
      case 'exists':
        EventTracking.view(this.props.eventScreenName, { ui_element_name: 'EmailMergeConfirmDialog' });
        return this.renderEmailMergeConfirmDialog(
          () => this.setState({ page: 'confirmation_code' }));

      case 'confirmation_code':
        return this.renderEmailMergeConfirmationCode(
          () => this.setState({ page: 'success' }));

      case 'success':
        EventTracking.view(this.props.eventScreenName, { ui_element_name: 'SuccessfulMerge' });
        return this.renderSuccessfulMergeConfirmation();

      default:
        return null;
    }
  }

  render() {
    return (
      this.getPage()
    );
  }
}

export default EmailMergeConfirmation;



// WEBPACK FOOTER //
// ./src/user/components/EmailMergeConfirmation.jsx